import { newAttemptId, reportWorkflow } from "./telemetry.js";
import { apiRequestContext, isExpectedValidationResponse } from "./apiRequestContext.js";

export function attachApiRequestTelemetry(instance, report = reportWorkflow) {
  const recent = [];
  const remember = (meta, outcome) => {
    recent.push({...meta.context, outcome, request_id:meta.requestId});
    if (recent.length > 8) recent.shift();
  };
  instance.interceptors.request.use(config => {
    try {
      const context = apiRequestContext(config, instance.defaults.baseURL);
      if (context) {
        config.headers = config.headers || {};
        const requestId = config.headers["X-Request-ID"] || newAttemptId();
        config.headers["X-Request-ID"] = requestId;
        config.headers["X-FTMC-Client"] = "web";
        config._ftmcTelemetry = {context, requestId, started:Date.now()};
      }
    } catch { /* Observability must not block a request. */ }
    return config;
  });
  instance.interceptors.response.use(response => {
    const meta = response.config?._ftmcTelemetry;
    if (meta) remember(meta, "succeeded");
    return response;
  }, error => {
    try {
      const response = error?.response, meta = error?.config?._ftmcTelemetry;
      if (meta) {
        const expected = isExpectedValidationResponse(response);
        remember(meta, expected ? "blocked" : "failed");
        if (response?.status === 422) report({
          workflow:"api_request", outcome:expected ? "blocked" : "failed",
          reason:expected ? "expected_422" : "unexpected_422", attemptId:meta.requestId,
          requestId:response.headers?.["x-request-id"] || meta.requestId,
          ...meta.context, http_status:422, recent_requests:[...recent],
          server_release:response.headers?.["x-ftmc-server-release"], durationMs:Date.now()-meta.started,
        });
      }
    } catch { /* Preserve the original error and its existing recovery UI. */ }
    return Promise.reject(error);
  });
}
